import { SeparatedProductsContainer } from './SeparatedProductsContainer';
export default SeparatedProductsContainer;
